import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";

import ApprovalRequestsTable from "../../components/ApprovalRequests/ApprovalRequestsTable";





const ApprovalRequestPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Approval Requests" />

        <ApprovalRequestsTable />

      </MasterLayout>
    </>
  );
};

export default ApprovalRequestPage;
